export default __webpack_public_path__ + "images/succusImg.1ff78e51.png";